module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//gorilla_6_2.png?v=654097a4";